/* Hyperush — motion behaviours. CSS does the animating; this only decides when.
   Every module is independent, wrapped in try/catch, and opts its own CSS in
   so the page still looks right if the script never runs. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COR = '#FF5A4D';

  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); }
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* --------------------------------------------------------- Shutter flash */
  var flashEl = null;
  function flash() {
    if (reduced) return;
    if (!flashEl) {
      flashEl = document.createElement('div');
      flashEl.className = 'hy-flash';
      document.body.appendChild(flashEl);
    }
    flashEl.classList.remove('is-firing');
    void flashEl.offsetWidth;
    flashEl.classList.add('is-firing');
  }

  /* --------------------------------------------- 1. First-load wordmark */
  var LETTERS = [
    'M7 0H0V28H7V14.5H13.5V28H20.277V7.5H7V0Z',
    'M29.5 7.5H22.5V22.772H35.337V25H25V32H42.5V7.5H35.5V16H29.5V7.5Z',
    'M45 7.5V32H51.9133V27.873H64.9011V7.5H45ZM52 21V14.5H58V21H52Z',
    'M67.5 7.5V27.9001H87.6706V21.5943H74.5V19.5H87.5718L87.5 7.5H67.5ZM80.5908 16.3535H74.5V14.1274H80.5908V16.3535Z',
    'M90 28H97V14.5728H106V7.5H90V28Z',
    'M106 27.8842V7.5H113.129V21H118.749V7.5H125.764V27.8842H106Z',
    'M128 28V21.5L139.776 21.6253V19.7084H128V7.5H146.824V14.5H135.187V16.281H146.824V28H128Z',
    'M149 27.891V0H156V7.5H169.149V27.891H162.309V14.5H156V27.891H149Z',
    'M171 27.8965H177.5V21.5H171V27.8965Z'
  ];

  function boot() {
    if (reduced) return;
    try { if (sessionStorage.getItem('hy-booted')) return; } catch (e) { return; }

    var wrap = document.createElement('div');
    wrap.className = 'hy-boot';

    var svg = '<svg viewBox="0 0 178 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">';
    for (var i = 0; i < LETTERS.length; i++) {
      var tx = (Math.random() * 44 - 22).toFixed(1);
      var ty = (Math.random() * 34 - 17).toFixed(1);
      var r = (Math.random() * 24 - 12).toFixed(1);
      var fill = i === LETTERS.length - 1 ? COR : '#0F1115';
      svg += '<path d="' + LETTERS[i] + '" fill="' + fill + '" style="--i:' + i +
             ';--tx:' + tx + 'px;--ty:' + ty + 'px;--r:' + r + 'deg"/>';
    }
    svg += '</svg>';
    wrap.innerHTML = svg;

    document.body.appendChild(wrap);
    try { sessionStorage.setItem('hy-booted', '1'); } catch (e) {}
    window.setTimeout(function () {
      if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
    }, 1600);
  }

  /* ------------------------------------------- 2. Gallery film advance */
  function gallery() {
    var g = document.querySelector('media-gallery');
    if (!g || reduced) return;

    var scroller = null;
    var all = g.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var ov = getComputedStyle(all[i]).overflowX;
      if ((ov === 'auto' || ov === 'scroll') && all[i].scrollWidth > all[i].clientWidth + 8) {
        scroller = all[i];
        break;
      }
    }
    if (!scroller) return;

    var last = Math.round(scroller.scrollLeft / (scroller.clientWidth || 1));
    var idle = null;
    on(scroller, 'scroll', function () {
      window.clearTimeout(idle);
      idle = window.setTimeout(function () {
        var w = scroller.clientWidth || 1;
        var idx = Math.round(scroller.scrollLeft / w);
        if (idx !== last) { last = idx; flash(); }
      }, 90);
    }, { passive: true });
  }

  /* ------------------------------------ 3. Add to cart prints a photo */
  function printPhoto() {
    if (reduced) return;

    var img = document.querySelector('media-gallery img');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;

    var from = img.getBoundingClientRect();
    if (!from.width || !from.height) return;

    var target = document.querySelector('cart-icon, .header-actions__cart-icon');
    var to = target ? target.getBoundingClientRect()
                    : { left: window.innerWidth - 46, top: 22, width: 24, height: 24 };

    var photo = document.createElement('div');
    photo.className = 'hy-photo';
    photo.innerHTML = '<img src="' + src + '" alt="">';
    document.body.appendChild(photo);

    var startX = from.left + from.width / 2 - 37;
    var startY = from.top + from.height / 2 - 44;
    var endX = to.left + to.width / 2 - 37;
    var endY = to.top + to.height / 2 - 44;

    photo.style.left = startX + 'px';
    photo.style.top = startY + 'px';

    flash();

    var anim = photo.animate([
      { transform: 'translate(0,26px) scale(.5) rotate(-6deg)', opacity: 0 },
      { transform: 'translate(0,0) scale(1) rotate(-3deg)', opacity: 1, offset: 0.26 },
      { transform: 'translate(0,-16px) scale(1.02) rotate(2deg)', opacity: 1, offset: 0.42 },
      {
        transform: 'translate(' + (endX - startX) + 'px,' + (endY - startY) + 'px) scale(.16) rotate(16deg)',
        opacity: 0.15
      }
    ], { duration: 1120, easing: 'cubic-bezier(.16,1,.3,1)' });

    function done() {
      if (photo.parentNode) photo.parentNode.removeChild(photo);
      if (target) {
        target.classList.remove('hy-cart-bump');
        void target.offsetWidth;
        target.classList.add('hy-cart-bump');
        window.setTimeout(function () { target.classList.remove('hy-cart-bump'); }, 520);
      }
    }
    anim.onfinish = done;
    window.setTimeout(done, 1400);
  }

  function addToCart() {
    on(document, 'click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('button[name="add"], .add-to-cart-button, .sticky-add-to-cart__button');
      if (!btn || btn.disabled) return;
      printPhoto();
    }, true);
  }

  /* --------------------------------------- 4. Price rolls on pack change */
  function priceRoll() {
    if (reduced || !('MutationObserver' in window)) return;

    each(document.querySelectorAll('.price-item__group.price'), function (node) {
      if (node.dataset.hyRoll) return;
      node.dataset.hyRoll = '1';
      node.classList.add('hy-roll');

      var lastText = node.textContent.trim();
      var mo = new MutationObserver(function () {
        var next = node.textContent.trim();
        if (next === lastText) return;
        lastText = next;
        node.classList.remove('is-in');
        void node.offsetWidth;
        node.classList.add('is-in');
        window.setTimeout(function () { node.classList.remove('is-in'); }, 340);
      });
      mo.observe(node, { childList: true, subtree: true, characterData: true });
    });
  }

  /* ------------------------------------------- 5. Reels rail focus */
  function reels() {
    var rail = document.querySelector('[data-hy-reels]');
    if (!rail) return;
    var cards = Array.prototype.slice.call(rail.querySelectorAll('.hy-reels__card'));
    if (!cards.length) return;

    if (reduced) {
      each(cards, function (c) { c.classList.add('is-focus'); });
      return;
    }

    rail.classList.add('is-live');

    function pick() {
      var mid = rail.scrollLeft + rail.clientWidth / 2;
      var best = null, bestD = Infinity;
      each(cards, function (c) {
        var cMid = c.offsetLeft + c.offsetWidth / 2;
        var d = Math.abs(cMid - mid);
        if (d < bestD) { bestD = d; best = c; }
      });
      each(cards, function (c) { c.classList.toggle('is-focus', c === best); });
    }

    var tick = null;
    on(rail, 'scroll', function () {
      if (tick) return;
      tick = window.requestAnimationFrame(function () { tick = null; pick(); });
    }, { passive: true });

    pick();
    window.setTimeout(pick, 400);
  }

  /* ------------------------------------------- 6. Spec rows wipe in */
  function specs() {
    var list = document.querySelector('.hy-spec__list');
    if (!list) return;
    var rows = list.querySelectorAll('.hy-spec__row');
    if (!rows.length) return;

    if (reduced || !('IntersectionObserver' in window)) return;

    list.setAttribute('data-hy-specs', '');

    var io = new IntersectionObserver(function (entries) {
      each(entries, function (en) {
        if (!en.isIntersecting) return;
        var i = Array.prototype.indexOf.call(rows, en.target);
        en.target.style.transitionDelay = (Math.min(i, 8) * 45) + 'ms';
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

    each(rows, function (r) { io.observe(r); });
    window.setTimeout(function () {
      each(rows, function (r) { r.classList.add('is-in'); });
    }, 4000);
  }

  /* ------------------------------- 7. Marquee follows scroll direction */
  function marquee() {
    if (reduced) return;
    var last = window.scrollY, tick = null;
    on(window, 'scroll', function () {
      if (tick) return;
      tick = window.requestAnimationFrame(function () {
        tick = null;
        var y = window.scrollY;
        if (Math.abs(y - last) > 6) {
          document.documentElement.setAttribute('data-hy-scroll', y < last ? 'up' : 'down');
          last = y;
        }
      });
    }, { passive: true });
  }

  /* --------------------------------------------------------- */
  function init() {
    try { boot(); } catch (e) {}
    try { gallery(); } catch (e) {}
    try { addToCart(); } catch (e) {}
    try { priceRoll(); } catch (e) {}
    try { reels(); } catch (e) {}
    try { specs(); } catch (e) {}
    try { marquee(); } catch (e) {}
  }

  ready(init);
  document.addEventListener('shopify:section:load', function () {
    try { reels(); } catch (e) {}
    try { specs(); } catch (e) {}
    try { priceRoll(); } catch (e) {}
  });
})();
